__turbopack_context__.v({
  "accordionSlideOverwrite": "screenExpandToggleButton-module-scss-module__xDIN4q__accordionSlideOverwrite",
  "fadeIn": "screenExpandToggleButton-module-scss-module__xDIN4q__fadeIn",
  "fadeOut": "screenExpandToggleButton-module-scss-module__xDIN4q__fadeOut",
  "scaleIn": "screenExpandToggleButton-module-scss-module__xDIN4q__scaleIn",
  "scaleOut": "screenExpandToggleButton-module-scss-module__xDIN4q__scaleOut",
  "screenExpandToggleButton": "screenExpandToggleButton-module-scss-module__xDIN4q__screenExpandToggleButton",
  "zoomIn": "screenExpandToggleButton-module-scss-module__xDIN4q__zoomIn",
  "zoomOut": "screenExpandToggleButton-module-scss-module__xDIN4q__zoomOut",
});
